export default {
	NO_DATA_IN_SELECTED_PERIOD: 'No Data in selected period',
	TITLE: 'Daily Report'
};